/** A new-game `ReachState` (M3 plan R5, §2.9 flow 1). */
import type { Galaxy } from '../../galaxy/types'
import type { ReachState, StandInState } from '../types'
import type { ReachStateConfig } from './config'
import { initialKnowledge } from './knowledge'

export interface HomeRef {
  systemId: string
  stationId: string
}

/**
 * A new game on `galaxy`: the initial knowledge, home at `home`, and `lastSafe` at the home station (a load
 * resumes at that station's hail point, so the position is only a fallback). `standIn` is null once M2 owns the
 * career.
 */
export function createReachState(galaxy: Galaxy, cfg: ReachStateConfig, home: HomeRef, standIn: StandInState | null): ReachState {
  return {
    galaxySeed: galaxy.seed,
    gameTime: 0,
    home: { systemId: home.systemId, stationId: home.stationId },
    lastSafe: { systemId: home.systemId, position: [0, 0, 0], rotation: [0, 0, 0, 1], stationId: home.stationId },
    knowledge: initialKnowledge(galaxy, cfg.knowledge),
    discoveredPois: {},
    relays: {},
    laneRings: {},
    deltas: {},
    charts: { unsold: {}, soldTotal: {}, firstDiscoveries: [] },
    route: null,
    navTarget: null,
    standIn,
  }
}
